module.exports = __webpack_public_path__ + "media/Caredo mix p01 07-09-2020 - w3.4f13538a.mp4";